import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts';
import { useState } from "react";
function Charts() {
    
    // Sample data for demonstration
    const data = [
        {
            hex_id: '882a100895fffff',
            avg_volume: 573.1,
            avg_co2: 163.85,
            avg_nox: 10.92,
            avg_pm25: 5.46,
            avg_noiselevels: 64.89,
            avg_speed: 43,
            time: '8:00 AM'
        },
        {
            hex_id: '882a100895fffff',
            avg_volume: 600.2,
            avg_co2: 168.1,
            avg_nox: 11.3,
            avg_pm25: 5.6,
            avg_noiselevels: 65.4,
            avg_speed: 38,
            time: '9:00 AM'
        },
        {
            hex_id: '882a100895fffff',
            avg_volume: 595.5,
            avg_co2: 170.2,
            avg_nox: 11.6,
            avg_pm25: 5.7,
            avg_noiselevels: 66.0,
            avg_speed: 40,
            time: '10:00 AM'
        },
        {
            hex_id: '882a100895fffff',
            avg_volume: 540.8,
            avg_co2: 172.0,
            avg_nox: 11.9,
            avg_pm25: 5.8,
            avg_noiselevels: 66.3,
            avg_speed: 48,
            time: '11:00 AM'
        },
        {
            hex_id: '882a100895fffff',
            avg_volume: 500.3,
            avg_co2: 175.4,
            avg_nox: 12.1,
            avg_pm25: 6.0,
            avg_noiselevels: 67.0,
            avg_speed: 52,
            time: '12:00 PM'
        },
        {
            hex_id: '882a100895fffff',
            avg_volume: 499.7,
            avg_co2: 178.6,
            avg_nox: 12.4,
            avg_pm25: 6.2,
            avg_noiselevels: 67.8,
            avg_speed: 50,
            time: '1:00 PM'
        },
        {
            hex_id: '882a100895fffff',
            avg_volume: 498.2,
            avg_co2: 180.3,
            avg_nox: 12.6,
            avg_pm25: 6.3,
            avg_noiselevels: 68.2,
            avg_speed: 51,
            time: '2:00 PM'
        },
        {
            hex_id: '882a100895fffff',
            avg_volume: 523.9,
            avg_co2: 183.7,
            avg_nox: 12.9,
            avg_pm25: 6.5,
            avg_noiselevels: 68.9,
            avg_speed: 48,
            time: '3:00 PM'
        },
        {
            hex_id: '882a100895fffff',
            avg_volume: 550.1,
            avg_co2: 185.2,
            avg_nox: 13.1,
            avg_pm25: 6.6,
            avg_noiselevels: 69.2,
            avg_speed: 45,
            time: '4:00 PM'
        },
        {
            hex_id: '882a100895fffff',
            avg_volume: 630.4,
            avg_co2: 188.0,
            avg_nox: 13.3,
            avg_pm25: 6.7,
            avg_noiselevels: 70.0,
            avg_speed: 40,
            time: '5:00 PM'
        }
    ];

    const TrafficChart = () => {

        const [trafficActiveTab, setTrafficActiveTab] = useState("avg_volume");

        const tabLabels = {
            avg_volume: "Average Volume",
            avg_speed: "Average Speed"
        };
        
        return (
            <div className="traffic-chart">

                <div style={{ display: "flex", gap: "10px", marginBottom: "10px" }}>
                    {Object.entries(tabLabels).map(([key, label]) => (
                        <button
                            className='filter-button'
                            key={key}
                            onClick={() => setTrafficActiveTab(key)}
                        >
                            {label}
                        </button>
                    ))}
                </div>

                  
                <ResponsiveContainer width={"100%"} height={300}>
                    <LineChart data={data} margin={{ top: 5, right: 20, bottom: 5, left: 0 }}>
                        <CartesianGrid stroke="#aaa" strokeDasharray="5 5" />
                        <Line 
                            type="monotone" 
                            dataKey={trafficActiveTab} 
                            stroke="#6ab33a" 
                            strokeWidth={2} 
                            name={tabLabels[trafficActiveTab]} 
                        />
                        <XAxis dataKey="time" />
                        <YAxis />
                        <Legend align="right" />
                        <Tooltip />
                    </LineChart>
                </ResponsiveContainer> 
            </div>
        );
    };

    const AQChart = () => {
        const [AQactiveTab, setAQactiveTab] = useState("avg_co2");
            
        const tabLabels = {
            avg_co2: "CO₂",
            avg_nox: "NOx",
            avg_pm25: "PM2.5"
        };

        return (
            <div className="aq-chart">
                
                <div style={{ display: "flex", gap: "10px", marginBottom: "10px" }}>
                    {Object.entries(tabLabels).map(([key, label]) => (
                        <button
                            className='filter-button'
                            key={key}
                            onClick={() => setAQactiveTab(key)}
                        >
                            {label}
                        </button>
                    ))}
                </div>

                
                <ResponsiveContainer width="100%" height={300}>
                    <LineChart data={data} margin={{ top: 5, right: 20, bottom: 5, left: 0 }}>
                        <CartesianGrid stroke="#aaa" strokeDasharray="5 5" />
                        <Line
                            type="monotone"
                            dataKey={AQactiveTab}
                            stroke="#6ab33a"
                            strokeWidth={2}
                            name={tabLabels[AQactiveTab]}
                        />
                        <XAxis dataKey="time" />
                        <YAxis />
                        <Legend />
                        <Tooltip />
                    </LineChart>
                </ResponsiveContainer>
            </div>
        );
    };

    return (
        <>
            <TrafficChart />
            <AQChart />
        </>
    );
}

export default Charts;